<template>
    <!-- `class` merges onto `DialogContent` when there is no default slot (Nuxt UI Slideover). -->
    <USlideover
        class="screen-lock-slideover-host"
        :dismissible="false"
        :overlay="true"
        :close="false"
        :style="{ zIndex: props.zIndex }"
        side="bottom"
        :ui="{
            overlay: props.transparent
                ? 'fixed inset-0 !bg-transparent'
                : 'fixed inset-0 !bg-(--ui-scrim)',
            content:
                '!bg-transparent shadow-none border-none ring-none divide-none !animate-none !text-white !opacity-100 [color-scheme:dark] data-[state=open]:!opacity-100 data-[state=closed]:!opacity-100',
        }"
    >
        <template #content>
            <!-- Transparent: still blocks taps; the triggering button shows the loading state. -->
            <div
                v-if="!props.transparent"
                class="fixed inset-0 flex flex-col items-center justify-center gap-4"
            >
                <div
                    class="h-12 w-12 border-4 border-white/75 border-t-transparent rounded-full animate-spin"
                    aria-hidden="true"
                />

                <p
                    v-if="message"
                    class="text-white text-3xl font-semibold max-w-md px-5 text-center"
                >
                    {{ message }}
                </p>
            </div>
        </template>
    </USlideover>
</template>

<script setup lang="ts">
const props = withDefaults(
    defineProps<{
        message?: string
        zIndex?: number
        transparent?: boolean
    }>(),
    {
        zIndex: 1000,
    }
)
</script>

<!-- Unscoped: `DialogContent` is inside `USlideover` and theme utilities outrank `ui.content` merges. -->
<style>
.screen-lock-slideover-host[data-dismissable-layer] {
    background-color: transparent !important;
    color: rgb(255 255 255) !important;
    animation: none !important;
    opacity: 1 !important;
}
</style>
